import { useContext } from 'react';
import { DeviceContext, type DeviceContextValue } from '@/contexts';

export function useDevice(): DeviceContextValue {
  const context = useContext(DeviceContext);
  if (!context) {
    throw new Error('useDevice must be used within a DeviceProvider');
  }
  return context;
}
